/* eslint-disable no-console */
import ZephrFeature from "components/zephr";
import { fetchBannerById } from "lib/fetchers/common";
import { ZEPHR_FEATURES } from "lib/zephr/constants";
import { useEffect, useState } from "react";
import BottomBannerContent from "./bottomBannerContent";
import { Banner } from "lib/types/banners";

type BottomBannerProps = {
  preview?: boolean;
};

const BottomBanner = ({ preview = false }: BottomBannerProps) => {
  const [banner, setBanner] = useState<Banner | null>(null);

  useEffect(() => {
    async function checkForBannerTrigger() {
      const triggerElement = document.querySelector(
        '[data-show-bottom-banner="true"]'
      );

      if (triggerElement) {
        const id = triggerElement.getAttribute("data-banner-id");
        if (id) {
          try {
            const data = await fetchBannerById({ id, preview });
            if (data) {
              setBanner(data);
            }
          } catch (error) {
            // eslint-disable-next-line no-console
            console.error("Failed to fetch banner data", error);
          }
        } else {
          // eslint-disable-next-line no-console
          console.error(
            "Banner trigger element found but no data-banner-id attribute"
          );
        }
      }
    }

    checkForBannerTrigger();
  }, [preview]);

  return (
    <>
      <ZephrFeature name={ZEPHR_FEATURES.SHOW_BOTTOM_BANNER} />
      <ZephrFeature name={ZEPHR_FEATURES.SHOW_BOTTOM_BANNER_ALT} />
      {banner !== null && (
        <BottomBannerContent key={banner.id} banner={banner} />
      )}
    </>
  );
};

export default BottomBanner;
